import { Dropdown } from '@wordpress/components';

const UnitsControl = ({ value, onChange, units }) => {
    return (
        <Dropdown
            className="faqmate-units-dropdown"
            contentClassName="faqmate-units-content-wrapper"
            position="bottom right"
            renderToggle={({ isOpen, onToggle }) => (
                <button className="faqmate-selected-unit" onClick={onToggle} aria-expanded={isOpen}>
                    {value}
                </button>
            )}
            renderContent={() => (
                <div className="faqmate-units-wrapper">
                    {units &&
                        units.map((u, index) => {
                            return (
                                <button
                                    className={`unit-btn ${u === value ? 'faqmate-active' : ''}`}
                                    key={index}
                                    onClick={() => {
                                        onChange(u);
                                    }}
                                >
                                    {u}
                                </button>
                            );
                        })}
                </div>
            )}
        />
    );
};

export default UnitsControl;
